module.exports = __webpack_public_path__ + "static/media/bulk_planning_status.00b5811c.csv";